import { ITranslationStrings, prepareLanguages } from '@gem/modules/i18n';
import { logger } from '@gem/modules/logger';

import { DEFAULT_LANGUAGE } from 'APP/constants/language';

async function downloadStrings(language: string): Promise<ITranslationStrings | null> {
  try {
    const strings = await import(`LANGS/${PROJECT_NAME}/${language}/Strings.json`);

    return strings.default;
  } catch (e) {
    logger.get('utils').error('downloadStrings', e);
    return null;
  }
}

export async function getTranslationStrings(language?: string): Promise<ITranslationStrings[]> {
  const { shortLanguage, shortDefaultLanguage } = prepareLanguages(language, DEFAULT_LANGUAGE);
  const currentLanguage = shortLanguage || shortDefaultLanguage;

  const stringsRequests = [];

  if (currentLanguage) {
    stringsRequests.push(downloadStrings(currentLanguage));
  }

  if (shortDefaultLanguage && currentLanguage !== shortDefaultLanguage) {
    stringsRequests.push(downloadStrings(shortDefaultLanguage));
  }

  if (!stringsRequests.length) {
    throw Error('[translations] Wrong configuration');
  }

  const stringsList = await Promise.all(stringsRequests);
  const filteredStringsList = stringsList.filter((strings) => !!strings);

  if (!filteredStringsList.length) {
    throw Error('[translations] Wrong configuration');
  }

  return filteredStringsList;
}
